import styled from 'styled-components';

export const MarkdownContent = styled.div`
  padding: var(--space-18) var(--space-5) var(--space-18);
  width: 100%;
  max-width: 884px;
`;
